import { useParams, Link } from 'react-router-dom';
import { useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import DramaGrid from '@/pages/home/components/DramaGrid';
import { dramas, categories } from '@/mocks/dramas';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const category = useMemo(() => {
    return categories.find((c) => c.slug === slug);
  }, [slug]);

  const filteredDramas = useMemo(() => {
    if (!slug || slug === 'all') return dramas;
    return dramas.filter((d) => d.categorySlug === slug);
  }, [slug]);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-20 pb-10 text-center">
          <h1 className="font-heading text-2xl text-foreground-900">分类不存在</h1>
          <Link to="/" className="text-primary-500 hover:underline mt-4 inline-block">返回首页</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <>
      <SchemaOrg
        type="CollectionPage"
        data={{
          name: `${category.name} - 萝卜影视`,
          description: `萝卜影视收录${category.name}电视剧全集与连续剧完整版，${category.name}大结局在线全集免费看。`,
          url: `https://www.luobotv.com/category/${slug}`,
          isPartOf: {
            '@type': 'WebSite',
            name: '萝卜影视',
            url: 'https://www.luobotv.com/',
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 pb-14">
          <div className="w-full px-4 md:px-6">
            {/* Breadcrumb */}
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: category.name },
                ]}
              />
            </div>

            {/* Header */}
            <div className="mb-10">
              <h1 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-2">
                {category.name}
              </h1>
              <p className="text-sm text-foreground-500">
                萝卜影视{category.name}频道，收录{category.name}电视剧全集与连续剧完整版，{category.name}大结局在线全集免费看，共 {filteredDramas.length} 部作品
              </p>
            </div>

            {/* Category quick nav */}
            <div className="flex items-center gap-2 overflow-x-auto pb-4 mb-8 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {/* Drama Grid */}
            <DramaGrid dramas={filteredDramas} />
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}